/**
 * Registers the register at `/`, order 10 — the operator's home screen, so it
 * sorts first in `opsNav` regardless of which other area's `routes.ts` lands
 * beside it. The plane is served from a host of its own, so its home is the
 * bare root rather than a prefix under someone else's.
 *
 * Plain `createElement`, not JSX: this file is `.ts`, matching
 * `../routes/contract.ts`'s own `OpsRoute.element: ReactNode` — a `.tsx`
 * extension is for a file JSX syntax needs, and a route table entry is data,
 * not a component.
 */

import { createElement } from 'react';
import { Building } from 'lucide-react';

import { defineCatalogue } from '../../i18n';
import type { OpsRouteBundle } from '../routes/contract';
import { OpsShell } from '../shell/OpsShell';
import { Register } from './Register';

const catalogue = defineCatalogue({ navLabel: 'Organizações' }, { navLabel: 'Organisations' });

export const bundle: OpsRouteBundle = {
  order: 10,
  routes: [
    { path: '/', element: createElement(OpsShell, null, createElement(Register)), kind: 'data' },
  ],
  nav: [{ path: '/', label: () => catalogue.t('navLabel'), icon: Building, kind: 'data' }],
};
